import { render } from "./MyPageAuth2.vue?vue&type=template&id=b40667d2&scoped=true&ts=true"
import script from "./MyPageAuth2.vue?vue&type=script&lang=ts"
export * from "./MyPageAuth2.vue?vue&type=script&lang=ts"

import "./MyPageAuth2.vue?vue&type=style&index=0&id=b40667d2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b40667d2"]])

export default __exports__